import { ShieldCheck, BadgeCheck, HeadphonesIcon, IndianRupee, UserCheck } from "lucide-react";

const badges = [
  { icon: ShieldCheck, text: "Police Verified Staff" },
  { icon: BadgeCheck, text: "Trained & Certified Caregivers" },
  { icon: HeadphonesIcon, text: "24/7 Customer Support" },
  { icon: IndianRupee, text: "Affordable Transparent Pricing" },
  { icon: UserCheck, text: "Background Checked" },
];

export default function TrustIndicators() {
  return (
    <section data-testid="trust-section" className="py-6 bg-white border-y border-slate-100">
      <div className="marquee-container">
        <div className="marquee-content">
          {badges.map((badge, i) => (
            <div key={i} className="inline-flex items-center gap-3 px-8 py-3">
              <badge.icon className="w-5 h-5 text-[#14B8A6] flex-shrink-0" strokeWidth={1.5} />
              <span className="text-sm font-semibold text-[#0F172A] font-body whitespace-nowrap">
                {badge.text}
              </span>
              <div className="w-1.5 h-1.5 rounded-full bg-[#14B8A6]/30 ml-4" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
